import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment.prod';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class ClasificacionService {

  API_URI = environment.API_URL;
  constructor(private http: HttpClient) { }

  getClasificaciones(){
    return this.http.get(`${this.API_URI}/clasificaciones`)
  }

  getClasificacion(id:string){
    return this.http.get(`${this.API_URI}/clasificaciones/${id}`);
  }

  actualizarClasificacion(id: string | number, datos: any): Observable<any> {
    return this.http.put(`${this.API_URI}/clasificaciones/${id}`, datos);
  }
  
  crearClasificacion(datos: any) {
    return this.http.post(`${this.API_URI}/clasificaciones`, datos);
  }

  eliminarClasificacion(id: string): Observable<any> {
    return this.http.delete(`${this.API_URI}/clasificaciones/${id}`);
  }

}
